import { render, staticRenderFns } from "./vc-single.vue?vue&type=template&id=a5c692e2&"
import script from "./vc-single.vue?vue&type=script&lang=js&"
export * from "./vc-single.vue?vue&type=script&lang=js&"
import style0 from "./vc-single.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports